(function () {
    'use strict';

    angular
        .module('planInitiativeModule')
        .controller('InitiativeUpdateStatusAssessDeliverablesListByQuarterController', Controller);

    Controller.$inject = ['$scope', '$timeout', '$state', '$stateParams', 'govNotificationDelay'];

    function Controller($scope, $timeout, $state, $stateParams, govNotificationDelay) {
        // TODO: Use new data to check next/prev pages
        // Group by quarter
        $scope.ctrlCtxt.activeIndex = _.indexOf($scope.fiscalYearQuarterKeys, $stateParams.FiscalYearQuarterKey);
        $scope.ctrlCtxt.isNextInitiative = false;
        $scope.ctrlCtxt.activeQuarter = $stateParams.FiscalYearQuarterKey;
        $scope.ctrlCtxt.activeFiscalYear = $scope.deliverableAssessmentsByQuarter[0].MilestoneGroup.TargetFiscalYear;
        $scope.ctrlCtxt.activeQuarterTitle = $scope.deliverableAssessmentsByQuarter[0].MilestoneGroup.TargetDateQuarterShortTitleEN;
        $scope.ctrlCtxt.nextQuarter = null;
        $scope.ctrlCtxt.prevQuarter = null;

        $scope.ctrlCtxt.startForwardFlip = $stateParams.toNext !== false;
        $scope.ctrlCtxt.startBackwardFlip = $stateParams.toPrevious;
        $scope.ctrlCtxt.readyForAnimation = true;
        $scope.ctrlCtxt.hideContent = false;
        $scope.ctrlCtxt.moveForward = null;

        $scope.ctrlCtxt.initPlanQuarters = function () {
            if ($scope.fiscalYearQuarterKeys.length > 1
                && $scope.ctrlCtxt.activeIndex + 1 < $scope.fiscalYearQuarterKeys.length) {
                $scope.ctrlCtxt.nextQuarter = $scope.fiscalYearQuarterKeys[$scope.ctrlCtxt.activeIndex + 1];
            } else {
                $scope.ctrlCtxt.isNextInitiative = true;
            }

            if ($scope.ctrlCtxt.activeIndex > 0) {
                $scope.ctrlCtxt.prevQuarter = $scope.fiscalYearQuarterKeys[$scope.ctrlCtxt.activeIndex - 1];
            }
        };

        $scope.continueAssessment = function () {
                $scope.ctrlCtxt.moveForward = true;
                $scope.ctrlCtxt.hideContent = true;

                $timeout(function () {
                    $state.go('initiativeUpdateStatusAssess.initiatives.assess.byInitiativeDeliverablesByQuarter', {
                        FiscalYearQuarterKey: $scope.ctrlCtxt.nextQuarter,
                        toNext: true,
                        toPrevious: false
                    });
                }, 150);
        };

        $scope.goToPrevAssessment = function () {
            $scope.ctrlCtxt.moveBackwards = true;
            $scope.ctrlCtxt.hideContent = true;
            $timeout(function () {
                $state.go('initiativeUpdateStatusAssess.initiatives.assess.byInitiativeDeliverablesByQuarter', {
                    FiscalYearQuarterKey: $scope.ctrlCtxt.prevQuarter,
                    toPrevious: true,
                    toNext: false
                });
            }, 150);
        };

        $scope.goToInitiative = function () {
            if ($scope.assessmentByInitiative.PlanInitiativeAssessment.AreAllDeliverablesAssessed) {
                $scope.ctrlCtxt.moveForward = true;
                $scope.ctrlCtxt.hideContent = true;
                $timeout(function () {
                    $state.go('initiativeUpdateStatusAssess.initiatives.assess.byInitiativeAssessment', {
                        PlanInitiativeID: $scope.planInitiative.PlanInitiativeID
                    });
                }, 150);

                return;
            }

            if (!$scope.isMissingAssessmentsShow) {
                $scope.isMissingAssessmentsShow = true;
                $timeout(function () {
                    $scope.isMissingAssessmentsShow = false;
                }, govNotificationDelay);
            }
        };
    }
})();
